import { gql } from '@apollo/client';
import { ResolverParams } from '@queries/queries.interfaces';
import { Address, Order } from '@interfaces';

export const getCheckoutAddress = () => gql`
  query getCheckoutAddress($params: CurrentOrderParams) {
    currentOrder(params: $params) {
      id
      deliveryType
      deliveryDate
      orderGroupId
      totalCost
      deliveryCost
      metadata {
        chargeDeliveryCost
      }
      orderDetails {
        id
        quantity
        product {
          id
          price
          availability {
            status
            stock
          }
          discount {
            price
            listPrice
          }
        }
      }
      address {
        ...BaseAddress
      }
    }
    addresses {
      ...BaseAddress
    }
  }
  fragment BaseAddress on Address {
    id
    uuid
    apartment
    commune
    region
    street
    streetNumber
    details
    name
    isConfirmed
    coords
  }
`;

export type GetCheckoutAddressQueryResponse = {
  addresses: Address[];
  currentOrder: Pick<
    Order,
    | 'id'
    | 'address'
    | 'deliveryType'
    | 'deliveryDate'
    | 'orderDetails'
    | 'deliveryCoupon'
    | 'orderGroupId'
    | 'totalCost'
    | 'deliveryCost'
    | 'metadata'
  >;
};

export type GetCheckoutAddressQueryParams = ResolverParams<{
  orderUuid: string;
}>;
